export const testScenarioDetailColumns = [
  {
    name: "Scenarios",
    selector: "scenario",
    grow: 5,
    tooltip: "Scenario Name",
  },
  {
    name: "KPI1",
    selector: "kpi1",
    tooltip:
      "CMBS warning signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI2",
    selector: "kpi2",
    tooltip:
      "CMBS Buzzer signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI3",
    selector: "kpi3",
    tooltip:
      "CMBS HUW signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI4",
    selector: "kpi4",
    tooltip:
      "CMBS Prefill signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI5",
    selector: "kpi5",
    tooltip:
      "CMBS Brake Level 1 signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI6",
    selector: "kpi6",
    tooltip:
      "CMBS Adaptive Brake signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI7",
    selector: "kpi7",
    tooltip:
      "CMBS Standstill signal shall not be activated in open loop public road data",
  },
  {
    name: "Result",
    selector: "result",
    tooltip: "Combined Result",
  },
];

export const testScenarioDetailDataPassed = [
  {
    scenario: "1100HND_p0507000-p000_20231015125000",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "1200JPN_p1004520-p000_20231015142256",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "1600EUR_p0501560-p090_20231015151217",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "3300EUR_p0255050-p000_4G40_20231015152009",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "4401EUR_p0503510-p090_20231015161654",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "6230EUR_p0504005-p000_20231015180622",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "6400EUR_p0751005-p090_20231015181137",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "6401EUR_p0504005-p090_20231015192808",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "1500EUR_p1005050-p180_20231015151032",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "6100IHS_p0256000-p000_20231015180242",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
];

export const testScenarioDetailDataFailed = [
  {
    scenario: "1100HND_p0507000-p000_20231015125000",
    kpi1: "FAIL",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "FAIL",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "1200JPN_p1004520-p000_20231015142256",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "FAIL",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "1600EUR_p0501560-p090_20231015151217",
    kpi1: "FAIL",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "FAIL",
    kpi5: "PASS",
    kpi6: "FAIL",
    kpi7: "FAIL",
    result: "PASS",
  },
  {
    scenario: "3300EUR_p0255050-p000_4G40_20231015152009",
    kpi1: "FAIL",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "FAIL",
    kpi6: "PASS",
    kpi7: "FAIL",
    result: "PASS",
  },
  {
    scenario: "4401EUR_p0503510-p090_20231015161654",
    kpi1: "FAIL",
    kpi2: "FAIL",
    kpi3: "FAIL",
    kpi4: "FAIL",
    kpi5: "FAIL",
    kpi6: "FAIL",
    kpi7: "FAIL",
    result: "FAIL",
  },
  {
    scenario: "6230EUR_p0504005-p000_20231015180622",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "FAIL",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "FAIL",
  },
  {
    scenario: "6400EUR_p0751005-p090_20231015181137",
    kpi1: "PASS",
    kpi2: "FAIL",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "6401EUR_p0504005-p090_20231015192808",
    kpi1: "FAIL",
    kpi2: "FAIL",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "PASS",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "1500EUR_p1005050-p180_20231015151032",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "FAIL",
    kpi6: "PASS",
    kpi7: "PASS",
    result: "PASS",
  },
  {
    scenario: "6100IHS_p0256000-p000_20231015180242",
    kpi1: "PASS",
    kpi2: "PASS",
    kpi3: "PASS",
    kpi4: "PASS",
    kpi5: "FAIL",
    kpi6: "FAIL",
    kpi7: "FAIL",
    result: "FAIL",
  },
];

export const kpiDetails = [
  {
    name: "KPI1",
    selector: "kpi1",
    summary:
      "CMBS warning signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI2",
    selector: "kpi2",
    summary:
      "CMBS Buzzer signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI3",
    selector: "kpi3",
    summary:
      "CMBS HUW signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI4",
    selector: "kpi4",
    summary:
      "CMBS Prefill signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI5",
    selector: "kpi5",
    summary:
      "CMBS Brake Level 1 signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI6",
    selector: "kpi6",
    summary:
      "CMBS Adaptive Brake signal shall not be activated in open loop public road data",
  },
  {
    name: "KPI7",
    selector: "kpi7",
    summary:
      "CMBS Standstill signal shall not be activated in open loop public road data",
  },
];


export const testScenariosExecutionColumns = [
  {
    name: "Test Case Status",
    selector: "test_case_status",
    grow: 5,
  },
  {
    name: "Count",
    selector: "count",
  },
];

export const testScenariosExecutionData = [
  {
    test_case_status: "Executed",
    count: 1000,
  },
  {
    test_case_status: "Passed",
    count: 800,
  },
  {
    test_case_status: "Failed",
    count: 120,
  },
  {
    test_case_status: "Interrupted",
    count: 80,
  },
];

export const testSignalCountColumns = [
  {
    name: "Parameter (Signal)",
    selector: "signal",
    grow: 5,
  },
  {
    name: "Activation",
    selector: "activation_count",
  },
];

export const testSignalCountData = [
  {
    signal: "Indicator Warning Instance",
    activation_count: 500,
  },
  {
    signal: "Buzzer Warning Instance",
    activation_count: 200,
  },
  {
    signal: "Prefill Instance",
    activation_count: 300,
  },
  {
    signal: "Brake Level Instance",
    activation_count: 90,
  },
  {
    signal: "Adaptive Brake Instance",
    activation_count: 90,
  },
  {
    signal: "Standstill Instance",
    activation_count: 90,
  },
  {
    signal: "EBA Instance",
    activation_count: 90,
  },
];
